import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import useWindowSize from "../../hooks/useWindowSize";
import Icon from "../Icon";
import styled from "styled-components";
import defaultAvatar from "../../defaultAvatar.png";

export default function SpeakersGrid({ speakers, congress, generateLink }) {
  const windowSize = useWindowSize();

  const getSpeakersQuantity = () => {
    const width = windowSize.width;

    if (width < 310) return 3;
    if (width < 400) return 5;
    if (width < 640) return 5;
    if (width > 1280) return 17;
    if (width > 1024) return 13;

    if (width < 770) return 11;

    if (width > 720) return 5;
    if (width > 640) return 7;
  };

  const sortedSpeakers = speakers.sort((a, b) => {
    if (a.PhotoURL && !b.PhotoURL) {
      return -1;
    } else if (!a.PhotoURL && b.PhotoURL) {
      return 1;
    } else {
      return 0;
    }
  });

  const slicedSpeakers = sortedSpeakers.slice(0, getSpeakersQuantity());

  return (
    <SpeakersContainer>
      {slicedSpeakers.map((item, index) => (
        <Link to={generateLink("/speakers")} key={`${index}-header`}>
          <StyledImage
            style={{
              border: `2px solid ${congress.PrimaryColor}`,
            }}
            src={item?.PhotoURL || defaultAvatar}
            alt={item.FirstNames}
          />
        </Link>
      ))}
      <StyledPlusButton>
        <Link
          to={generateLink("/speakers")}
          className="PlusButton"
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            borderRadius: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Icon icon="plus" size={"20"} />
        </Link>
      </StyledPlusButton>
    </SpeakersContainer>
  );
}

const StyledPlusButton = styled.div`
  width: 80px;
  height: 80px;

  @media screen and (max-width: 400px) {
    width: 60px;
    height: 60px;
  }
`;

const StyledImage = styled.img`
  border-radius: 100%;
  width: 80px;
  height: 80px;
  flex-shrink: none;

  object-fit: cover;

  @media screen and (max-width: 400px) {
    width: 60px;
    height: 60px;
  }
`;
const SpeakersContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  width: auto;
  flex-wrap: wrap;
  padding: 1rem 2rem;
  padding-top: 0;
  height: 200px;
  overflow: hidden;

  @media screen and (max-width: 480px) {
    padding: 1rem 2rem;
  }
`;
